<template>
    <div class="draw-animation-container">
        <!-- Animation will be rendered here -->
        <div id="app-container" class="relative w-screen h-screen">
            <!-- Scene 2: Results Animation -->
            <div id="scene-results" class="scene active w-full h-full absolute top-0 left-0 bg-gradient-to-br from-orange-500 to-amber-500 flex flex-col items-center p-4">
                <!-- Header -->
                <div class="absolute top-0 left-0 right-0 p-4 bg-orange-600 shadow-lg flex justify-between items-center z-20">
                    <div class="header-logo text-left logo-text">
                        <div class="logo-text-lucky">LUCKY</div>
                        <div class="logo-text-numbers">
                            <span class="text-white">5</span>
                            <span class="text-purple-700">90</span>
                        </div>
                    </div>
                    <h2 class="text-2xl text-white font-bold text-right">{{ formattedDate }}</h2>
                </div>
                
                <!-- Title Bar -->
                <div class="title-bar">
                    <h1 class="text-4xl text-white font-black text-center">{{ eventName }}</h1>
                </div>

                <!-- Content: Balls -->
                <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl text-center h-48">
                    <!-- 5 premières boules -->
                    <div id="category-premieres" class="reveal-item">
                        <div class="flex flex-wrap gap-4 justify-center">
                            <div v-for="(num, index) in firstFive" :key="index" class="ball bg-green-400">
                                <span>{{ num }}</span>
                            </div>
                        </div>
                        <h2 class="text-3xl font-bold text-white mb-4" style="text-shadow: 2px 2px 4px rgba(0,0,0,0.3);">5 premières boules</h2>
                    </div>
                    
                    <!-- 2 boules bonus -->
                    <div id="category-bonus" class="reveal-item">
                        <div class="flex flex-wrap gap-4 justify-center">
                            <div v-for="(num, index) in bonusTwo" :key="index" class="ball bg-cyan-400">
                                <span>{{ num }}</span>
                            </div>
                        </div>
                        <h2 class="text-3xl font-bold text-white mb-4" style="text-shadow: 2px 2px 4px rgba(0,0,0,0.3);">2 boules bonus</h2>
                    </div>
                    
                    <!-- 5 dernières boules -->
                    <div id="category-dernieres" class="reveal-item">
                        <div class="flex flex-wrap gap-4 justify-center">
                            <div v-for="(num, index) in lastFive" :key="index" class="ball bg-purple-500 text-white">
                                <span>{{ num }}</span>
                            </div>
                        </div>
                        <h2 class="text-3xl font-bold text-white mb-4" style="text-shadow: 2px 2px 4px rgba(0,0,0,0.3);">5 dernières boules</h2>
                    </div>
                    
                    <!-- 2 boules joker -->
                    <div id="category-joker" class="reveal-item">
                        <div class="flex flex-wrap gap-4 justify-center">
                            <div v-for="(num, index) in jokerTwo" :key="index" class="ball bg-fuchsia-500 text-white">
                                <span>{{ num }}</span>
                            </div>
                        </div>
                        <h2 class="text-3xl font-bold text-white mb-4" style="text-shadow: 2px 2px 4px rgba(0,0,0,0.3);">2 boules joker</h2>
                    </div>
                </div>
                
                <!-- Footer -->
                <div class="absolute bottom-4 right-4 text-white font-bold text-lg">
                    luckiabet 21+
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DrawAnimation',
    data() {
        return {
            firstFive: [],
            bonusTwo: [],
            lastFive: [],
            jokerTwo: [],
            eventName: '',
            formattedDate: '',
        }
    },
    mounted() {
        this.parseDrawData()
        // Wait a bit for DOM to be ready
        this.$nextTick(() => {
            setTimeout(() => {
                this.startAnimation()
            }, 500)
        })
    },
    methods: {
        parseDrawData() {
            // Get data from query params
            const query = this.$route?.query || {}
            
            // Parse results from query string (JSON encoded)
            if (query.results) {
                try {
                    const results = JSON.parse(decodeURIComponent(query.results))
                    this.firstFive = Array.isArray(results.firstFive) ? results.firstFive : []
                    this.bonusTwo = Array.isArray(results.bonusTwo) ? results.bonusTwo : []
                    this.lastFive = Array.isArray(results.lastFive) ? results.lastFive : []
                    this.jokerTwo = Array.isArray(results.jokerTwo) ? results.jokerTwo : []
                } catch (e) {
                    console.error('Error parsing results:', e)
                }
            }
            
            // Get event name and date
            this.eventName = query.eventName || 'Le Big'
            this.formattedDate = query.date || new Date().toLocaleDateString('fr-FR', { 
                weekday: 'long', 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            })
        },
        
        async startAnimation() {
            const categories = ['#category-premieres', '#category-bonus', '#category-dernieres', '#category-joker']
            
            for (let i = 0; i < categories.length; i++) {
                const category = document.querySelector(categories[i])
                if (!category) continue
                
                // Slide in
                category.classList.remove('slide-out')
                category.classList.add('slide-in')
                
                await this.sleep(600)
                
                // Reveal balls
                const balls = category.querySelectorAll('.ball')
                for (const ball of balls) {
                    await this.sleep(300)
                    ball.classList.add('visible')
                }
                
                await this.sleep(2000)
                
                // Slide out (except last)
                if (i < categories.length - 1) {
                    category.classList.remove('slide-in')
                    category.classList.add('slide-out')
                    await this.sleep(600)
                }
            }
        },
        
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        }
    }
}
</script>

<style scoped>
/* Import styles from the HTML template */
@import './draw-animation.scss';
</style>

